import {withStyles} from '@mui/styles'
import {Tab, Tabs} from '@mui/material'
import {rxrTintColor, rxrDarkGreyColor, rxrGreyColor} from '../assets/styles/color'
import React from 'react'

export const AntTab = withStyles(theme => ({
  root: {
    textAlign: 'left',
    marginTop: 10,
    paddingBottom: 10,
    marginLeft: 18,
    textTransform: 'none',
    minWidth: 72,
    fontSize: 18,
    color: rxrDarkGreyColor,
    fontWeight: 700,
    '&:hover': {
      color: rxrTintColor,
      opacity: 1,
    },
    '&:focus': {
      color: rxrTintColor,
      outline: 'none',
    },
  },
  selected: {color: `${rxrTintColor} !important`, fontWeight: 700},
}))(props => <Tab disableRipple {...props} />)

export const AntTabs = withStyles({
  indicator: {
    backgroundColor: rxrTintColor,
    borderBottom: '4px solid ' + rxrTintColor,
  },
})(props => <Tabs {...props} variant="scrollable" scrollButtons="auto" />)
